module.exports = __webpack_public_path__ + "static/media/react-native.5d6ecb8b.png";